import { ListingType } from 'app/types/listing';
import { LoanStatus, type Loan } from 'app/types/loan';

/** The API exposes the linked offer only to its lender; never replace canonical loan IDs. */
export function getLoanDisplayListing(loan: Loan) {
  if (
    loan.linkedOffer &&
    loan.listing?.type === ListingType.request &&
    loan.linkedOffer.userId === loan.lenderId &&
    [LoanStatus.Accepted, LoanStatus.Returned, LoanStatus.Completed].includes(loan.status)
  ) {
    return loan.linkedOffer;
  }
  return loan.listing;
}
